import { render } from "./CardCenter.vue?vue&type=template&id=13f47e2a&scoped=true"
import script from "./CardCenter.vue?vue&type=script&lang=js"
export * from "./CardCenter.vue?vue&type=script&lang=js"

import "./CardCenter.vue?vue&type=style&index=0&id=13f47e2a&scoped=true&lang=css"
import "./CardCenter.vue?vue&type=style&index=1&id=13f47e2a&lang=css"

import exportComponent from "/root/.jenkins/workspace/hidoc/hidoc-web/03_SRC/hidoc-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13f47e2a"]])

export default __exports__